import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Result, Button } from "antd";
import { API_BASE_URL } from "../../../utils/BaseUrl";

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderCode = params.get("orderCode");
    const userStr = localStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : null;

    const confirmPayment = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/api/Payment/confirm-payment`,
          null,
          {
            params: {
              orderCode: orderCode,
              userId: user.userId,
            },
          }
        );

        console.log("✅ Thanh toán đã được xác nhận!", res.data);

        // CẬP NHẬT USER ROLE trong localStorage
        const updatedUser = { ...user, role: "GymOwner" };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        console.log("✅ Cập nhật thông tin user vào localStorage:", updatedUser);

        // Đánh dấu đã reload để tránh reload vòng lặp
        if (!sessionStorage.getItem("hasReloaded")) {
          sessionStorage.setItem("hasReloaded", "true");
          window.location.reload();
        }

      } catch (error) {
        if (error.response) {
          console.error("❌ Xác nhận thanh toán thất bại:", error.response.data);
        } else {
          console.error("⚠️ Lỗi khi xác nhận thanh toán:", error.message);
        }
      }
    };

    if (orderCode && user) {
      confirmPayment();
    } else {
      console.warn("Không tìm thấy orderCode hoặc user trong localStorage.");
    }
  }, [location.search]); // chạy mỗi khi URL thay đổi, hoặc bạn có thể để [] nếu chắc chắn URL không đổi

  // Hiển thị thông tin mã đơn hàng dựa vào URL
  const params = new URLSearchParams(location.search);
  const orderCode = params.get("orderCode");

  return (
    <Result
      status="success"
      title="Thanh toán thành công!"
      subTitle={`Mã đơn hàng: ${orderCode}`}
      extra={[
        <Button
          type="primary"
          key="home"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Về trang chủ
        </Button>

      ]}
    />
  );
};

export default Success;
